import React, { useEffect, useState } from "react";

import useTranslation from "next-translate/useTranslation";
import styles from "./styles/Lobby.module.css";
import LobbyPopups from "./popups/LobbyPopups";
import Head from "next/head";
import {
  useLobby,
  enterLobby,
  // exitLobby,
  showChallengePopup,
  chooseGame,
  setTab,
} from "../../ducks/lobby";
import {
  CREATE_GAME_TAB,
  DAILY_TAB,
  LIVE_GAME_TAB,
  // CREATE_GAME_TAB,
  // DAILY_TAB,
  // LIVE_GAME_TAB,
  ModeIds,
  TimeControl,
  VARIANT_CHESS,
} from "@chesshotel/constants";
import { getModeId } from "../../util/util";
// import {  } from "../ducks/lobby";
import { REGULAR_TIER, UNLIMITED_TIER } from "@chesshotel/constants";
// import { getModeId } from "../../util/util";
import LobbyBody from "./LobbyBody";
import PlayWire from "../../components/PlayWire";
import {
  ADS_PROVIDER_YANDEX,
  ADS_PROVIDER_ADSENSE,
  ADS_PROVIDER_PLAYWIRE,
  useSiteData,
} from "../../ducks/siteData";
import { useMembership } from "../../ducks/membership";
import AdSense from "../../components/AdSense";
import { useRouter } from "next/router";
import ChallengePopup from "../challenge/ChallengePopup";
import CustomGamePopup from "./popups/CustomGamePopup";
// import { useSize } from "../../hooks/useSize";
import LobbyHead from "./LobbyHead";
// import LeagueCardContainer from "./infoCards/LeagueCardContainer";
// import PracticeCardContainer from "./infoCards/PracticeCardContainer";
// import { useSignIn } from "@/ducks/signIn";
// import SpinnerPage from "@/components/SpinnerPage";
// import { useUser } from "@/ducks/user";
import CreateGame from "./CreateGame";
import { useSettings } from "@/ducks/settings";
import Script from "next/script";
// import Script from "next/script";

// export function useIsHydrated() {
//   const [hydrated, setHydrated] = useState(false);

//   useEffect(() => {
//     setHydrated(true);
//   }, []);

//   return hydrated;
// }

function initLobbyChosenGame() {
  try {
    const timeVal = localStorage.getItem("chosenTime");
    const incVal = localStorage.getItem("chosenInc");
    const variantVal = localStorage.getItem("chosenVariant");
    const turnLengthVal = localStorage.getItem("turnLength");
    const timeControlVal = localStorage.getItem("timeControl");

    const time = timeVal ? parseInt(timeVal) : 10;
    const inc = incVal ? parseInt(incVal) : 0;
    const variant = variantVal ? parseInt(variantVal) : VARIANT_CHESS;
    const timeControl = timeControlVal
      ? parseInt(timeControlVal)
      : TimeControl.LIVE;
    const turnLength = turnLengthVal ? parseInt(turnLengthVal) : 2;

    if (timeControl == TimeControl.LIVE) {
      if (typeof window !== "undefined") {
        if (window.innerWidth <= 768) {
          setTab(CREATE_GAME_TAB);
        } else {
          setTab(LIVE_GAME_TAB);
        }
      }
    } else {
      setTab(DAILY_TAB);
    }

    chooseGame({
      time,
      inc,
      variant,
      modeId: getModeId(time, variant, timeControl),
      turnLength,
      timeControl,
    });
  } catch (e) {
    chooseGame({
      time: 10,
      inc: 0,
      variant: VARIANT_CHESS,
      modeId: ModeIds.RAPID,
      timeControl: TimeControl.LIVE,
      turnLength: 2,
    });
  }
}

async function initPlayWire(isDesktop) {
  const pwUnits = [];

  // if (sideAd && isDesktop) {
  //   pwUnits.push({
  //     selectorId: "lobby_skyscraper_left",
  //     type: "sky_atf",
  //   });
  if (isDesktop) {
    pwUnits.push({
      selectorId: "lobby_skyscraper_right",
      type: "sky_atf",
    });
  } else {
    pwUnits.push({
      selectorId: "lobby_bottom",
      type: "leaderboard_atf",
    });
  }
  // pwUnits.push({
  //   selectorId: "lobby_bottom",
  //   type: "leaderboard_btf",
  // });
  // }

  if (window.ramp) {
    try {
      await window.ramp.destroyUnits("all");
      await window.ramp.addUnits(pwUnits);
      await window.ramp.displayUnits();
    } catch (error) {
      console.log(error);
    }
  }
}

function initYandex(isDesktop) {
  // window.yaContextCb.push(() => {
  //   window.Ya.Context.AdvManager.render({
  //     renderTo: "yandex_rtb_R-A-1674804-8",
  //     blockId: "R-A-1674804-8",
  //   });
  // });

  if (isDesktop) {
    window.yaContextCb.push(() => {
      window.Ya.Context.AdvManager.render({
        renderTo: "yandex_rtb_R-A-1674804-5",
        blockId: "R-A-1674804-5",
      });
    });
  } else {
    window.yaContextCb.push(() => {
      window.Ya.Context.AdvManager.render({
        renderTo: "yandex_rtb_R-A-1674804-9",
        blockId: "R-A-1674804-7",
      });
    });
  }
}

export default function Lobby() {
  const { t } = useTranslation("common");

  const { leaguePlay, customGamePopupVisible, challengePopupVisible } =
    useLobby();
  const { adsVisible, adsProvider } = useSiteData();
  const { tier } = useMembership();
  // const { loading } = useSignIn();
  // const { memberLoggedIn } = useUser();
  const { chessSet, isDesktop } = useSettings();

  const router = useRouter();

  // useEffect(() => {
  //   if (memberLoggedIn) {
  //     setGuestFilter();
  //   }
  // }, [memberLoggedIn]);

  // useEffect(() => {
  //   initLobbyChosenGame();
  //   window.scrollTo(0, 0);
  //   enterLobby();
  //   router.prefetch("/game");
  // }, []);

  useEffect(() => {
    if (
      !adsVisible ||
      isDesktop === null ||
      tier === REGULAR_TIER ||
      tier === UNLIMITED_TIER
    ) {
      return;
    }

    if (adsProvider === ADS_PROVIDER_PLAYWIRE) {
      initPlayWire(isDesktop);
    } else if (adsProvider === ADS_PROVIDER_YANDEX) {
      initYandex(isDesktop);
    }
  }, [adsVisible, adsProvider, tier, isDesktop]);

  // const hydrated = useIsHydrated();

  useEffect(() => {
    initLobbyChosenGame(); // this will now run after hydration only
    window.scrollTo(0, 0);
    enterLobby();
    router.prefetch("/game");
  }, []);

  // if (!hydrated)
  //   return <div className="min-h-[715px] md:min-h-[665px] w-full"></div>;

  function renderSideAdRight() {
    switch (adsProvider) {
      case ADS_PROVIDER_PLAYWIRE:
        return (
          <PlayWire
            id="lobby_skyscraper_right"
            className="flex flex-col md:w-[160px] h-[600px]"
            contStyles="h-[600px]"
          />
        );

      case ADS_PROVIDER_ADSENSE:
        return (
          <AdSense
            adStyles={styles.sideAd}
            showRemoveAds={false}
            slot="7152821243"
            format="auto"
            insStyle={{ width: "100%" }}
          />
        );

      case ADS_PROVIDER_YANDEX:
        return <div id="yandex_rtb_R-A-1674804-5"></div>;

      default:
        return null;
    }
  }

  function renderFooterAd() {
    if (tier === REGULAR_TIER || tier === UNLIMITED_TIER) {
      return null;
    }

    switch (adsProvider) {
      case ADS_PROVIDER_PLAYWIRE:
        return <PlayWire id="lobby_bottom" className={styles.footerAd} />;

      case ADS_PROVIDER_ADSENSE:
        return (
          <AdSense
            adStyles={styles.footerAd}
            showRemoveAds={false}
            slot="6991788029"
            format="auto"
            insStyle={{ width: "100%", height: "120px" }}
          />
        );
      case ADS_PROVIDER_YANDEX:
        return (
          <div className={styles.footerAd} id="yandex_rtb_R-A-1674804-9"></div>
        );

      default:
        return <div className={styles.footerAd}></div>;
    }
  }

  // if (loading) {
  //   return <SpinnerPage />;
  // }

  return (
    <>
      <Head>
        <title>Chess Hotel | Lobby</title>
        <meta name="description" content={t("description")} />
        <meta name="keywords" content={t("keywords")} />
        <link
          rel="preload"
          as="image"
          href={`/images/pieces/${chessSet}/bK.svg`}
        />
        <link
          rel="preload"
          as="image"
          href={`/images/pieces/${chessSet}/bQ.svg`}
        />
        <link
          rel="preload"
          as="image"
          href={`/images/pieces/${chessSet}/bR.svg`}
        />
        <link
          rel="preload"
          as="image"
          href={`/images/pieces/${chessSet}/bN.svg`}
        />
        <link
          rel="preload"
          as="image"
          href={`/images/pieces/${chessSet}/bB.svg`}
        />
        <link
          rel="preload"
          as="image"
          href={`/images/pieces/${chessSet}/bP.svg`}
        />
        <link
          rel="preload"
          as="image"
          href={`/images/pieces/${chessSet}/wK.svg`}
        />
        <link
          rel="preload"
          as="image"
          href={`/images/pieces/${chessSet}/wQ.svg`}
        />
        <link
          rel="preload"
          as="image"
          href={`/images/pieces/${chessSet}/wR.svg`}
        />
        <link
          rel="preload"
          as="image"
          href={`/images/pieces/${chessSet}/wN.svg`}
        />
        <link
          rel="preload"
          as="image"
          href={`/images/pieces/${chessSet}/wB.svg`}
        />
        <link
          rel="preload"
          as="image"
          href={`/images/pieces/${chessSet}/wP.svg`}
        />
        <link rel="preload" as="image" href={`/images/board/${chessSet}.svg`} />
        <link rel="preload" as="audio" href="/sounds/metal_gong3.mp3" />
        <link rel="preload" as="audio" href="/sounds/take2.mp3" />
        <link rel="preload" as="audio" href="/sounds/move3.mp3" />
        <link rel="preload" as="audio" href="/sounds/bubble.mp3" />
      </Head>
      {customGamePopupVisible && <CustomGamePopup />}
      {challengePopupVisible && (
        <ChallengePopup
          onClose={() => showChallengePopup(false)}
          friend={null}
        />
      )}
      <LobbyPopups />
      <div className="flex w-full">
        <div className="flex justify-center w-full px-1 pb-4 shrink md:px-2">
          <div className="flex flex-col w-full max-w-[1000px] px-2 md:px-0">
            <LobbyHead />
            <div className="flex flex-col w-full mb-3 md:flex-row md:justify-center md:mb-4 ">
              <div className="flex flex-col shrink basis-7/12 rounded-t-xl rounded-b-md">
                <LobbyBody isDesktop={isDesktop} />
              </div>
              <div className="relative flex-col hidden w-full md:flex md:basis-5/12 md:shrink-0 md:ml-4 ">
                <CreateGame isDesktop={isDesktop} />
              </div>
            </div>
            {!isDesktop && renderFooterAd()}
          </div>
        </div>
        {tier !== REGULAR_TIER && tier !== UNLIMITED_TIER ? (
          <div className="hidden md:flex shrink-0 transition-none md:w-[184px] p-3 h-[624px] bg-gray-200">
            {isDesktop && renderSideAdRight()}
          </div>
        ) : (
          <div className="hidden w-0 transition-all duration-500 bg-gray-200 md:flex"></div>
        )}
      </div>
      <div id={styles.preload}>
        <img src={`/images/pieces/${chessSet}/bK.svg`} />
        <img src={`/images/pieces/${chessSet}/bQ.svg`} />
        <img src={`/images/pieces/${chessSet}/bR.svg`} />
        <img src={`/images/pieces/${chessSet}/bN.svg`} />
        <img src={`/images/pieces/${chessSet}/bB.svg`} />
        <img src={`/images/pieces/${chessSet}/bP.svg`} />
        <img src={`/images/pieces/${chessSet}/wK.svg`} />
        <img src={`/images/pieces/${chessSet}/wQ.svg`} />
        <img src={`/images/pieces/${chessSet}/wR.svg`} />
        <img src={`/images/pieces/${chessSet}/wN.svg`} />
        <img src={`/images/pieces/${chessSet}/wB.svg`} />
        <img src={`/images/pieces/${chessSet}/wP.svg`} />
        <img src={`/images/board/${chessSet}.svg`} />
      </div>
    </>
  );
}
